// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__UPN3q","HeroContaner":"hero_HeroContaner__hozTP","heroContent":"hero_heroContent__1uCc7","heroImage":"hero_heroImage__I4crV"};